export default "__VITE_ASSET__0e055797__"